(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lsg-global-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const bind = (header) => {
    if (!header || header.dataset.lsgMenuBound === 'true') return;
    header.dataset.lsgMenuBound = 'true';

    const menu = header.querySelector('.lsg-site-menu');
    const summary = menu && menu.querySelector('summary');
    if (!menu || !summary) return;

    const measure = () => {
      const h = Math.ceil(header.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--lsg-header-height', h + 'px');
      document.body.style.setProperty('--header-height', h + 'px');
      document.body.style.setProperty('--header-group-height', h + 'px');
    };

    const languages = header.querySelector('.lsg-language-disclosure');
    if (languages) {
      const trigger = languages.querySelector('summary');
      languages.addEventListener('toggle', () => trigger.setAttribute('aria-expanded', String(languages.open)));
      document.addEventListener('pointerdown', event => { if (languages.open && !languages.contains(event.target)) languages.open = false; });
      document.addEventListener('keydown', event => { if (event.key === 'Escape' && languages.open) { languages.open = false; trigger.focus(); } });
    }

    measure();
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(header);

    const sync = () => summary.setAttribute('aria-expanded', String(menu.open));
    menu.addEventListener('toggle', sync);

    menu.addEventListener('click', (event) => {
      if (event.target.closest('a')) {
        menu.open = false;
        sync();
      }
    });

    document.addEventListener('pointerdown', (event) => {
      if (menu.open && !menu.contains(event.target)) {
        menu.open = false;
        sync();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.open) {
        menu.open = false;
        sync();
        summary.focus();
      }
    });

    window.addEventListener('pageshow', () => {
      menu.open = false;
      sync();
    });

    const desktop = window.matchMedia('(min-width:1161px)');
    const onDesktopChange = (event) => {
      if (event.matches) {
        menu.open = false;
        sync();
      }
    };
    if (desktop.addEventListener) desktop.addEventListener('change', onDesktopChange);

    sync();
  };

  const init = () => document.querySelectorAll('.lsg-site-header').forEach(bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lsg-intelligence-beta"] && !Shopify.designMode) return;
  try {
    
(() => {
  const clamp = n => Math.max(0, Math.min(100, Math.round(n)));
  const sleep = ms => new Promise(r => setTimeout(r, ms));
  document.querySelectorAll('[data-lsg-ie]').forEach(root => {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';
    const form = root.querySelector('[data-form]');
    const idle = root.querySelector('[data-idle]');
    const scanner = root.querySelector('[data-scanner]');
    const results = root.querySelector('[data-results]');
    const run = root.querySelector('[data-run]');
    const error = root.querySelector('[data-error]');
    const names = {reactivate:root.dataset.playbookReactivate,capture:root.dataset.playbookCapture,create_demand:root.dataset.playbookCreate};
    const signalNames = {booking_path_friction:root.dataset.signalBooking,dormant_first_party:root.dataset.signalDormant,weak_market_capture:root.dataset.signalCapture,insufficient_market_demand:root.dataset.signalDemand,recovery_urgency:root.dataset.signalUrgency};
    const desc = {booking_path_friction:root.dataset.descBooking,dormant_first_party:root.dataset.descDormant,weak_market_capture:root.dataset.descCapture,insufficient_market_demand:root.dataset.descDemand,recovery_urgency:root.dataset.descUrgency};
    const urgencyNames = {critical:root.dataset.urgencyCritical,high:root.dataset.urgencyHigh,medium:root.dataset.urgencyMedium,normal:root.dataset.urgencyNormal};

    const score = c => {
      const s={reactivate:35,capture:35,create_demand:30};
      if(c.crm>=2000)s.reactivate+=28;else if(c.crm>=500)s.reactivate+=18;else if(c.crm<100)s.reactivate-=22;
      if(c.dta>=7&&c.dta<=45)s.reactivate+=12;else if(c.dta>60)s.reactivate-=5;
      if(c.segment)s.reactivate+=10;
      if(c.demand==='high')s.capture+=28;else if(c.demand==='medium')s.capture+=12;else s.capture-=14;
      s.capture+=c.booking?10:-15;if(c.direct<.25)s.capture+=8;
      if(c.demand==='low')s.create_demand+=22;if(c.dta>=21)s.create_demand+=14;else if(c.dta<10)s.create_demand-=20;
      if(c.partners)s.create_demand+=16;
      if(c.occ<.4&&c.dta<=14){s.reactivate+=8;s.capture+=8;s.create_demand-=6}
      return Object.fromEntries(Object.entries(s).map(([k,v])=>[k,clamp(v)]));
    };

    const diagnosis = (c,gap) => {
      const f=[];
      if(!c.booking)f.push(['booking_path_friction',90]);
      if(c.crm>=500)f.push(['dormant_first_party',c.crm>=2000?78:60]);
      if(c.demand==='low')f.push(['insufficient_market_demand',c.dta>=21?75:65]);
      if(c.demand!=='low')f.push(['weak_market_capture',c.direct<.25?72:55]);
      if(gap>0&&c.dta<=14)f.push(['recovery_urgency',c.dta<=7?88:76]);
      return f.sort((a,b)=>b[1]-a[1])[0][0];
    };

    const actionPlan = (primary, signal, urgency, c, pace) => {
      const recheck = urgency==='critical' ? '24 hours' : urgency==='high' ? '48 hours' : urgency==='medium' ? '5 days' : '7 days';
      if(signal==='booking_path_friction'){
        return {
          doNow:'Repair the direct booking path before adding more demand. Check mobile flow, availability, rate clarity and cancellation terms.',
          measure:'Booking-engine completion, mobile friction, availability consistency and conversion.',
          recheck,
          trigger:'Once the path is clean, execute '+names[primary]+' and compare pickup against the required pace.'
        };
      }
      const plans={
        reactivate:{
          doNow:'Activate qualified past guests for these exact dates with one direct, date-specific proposition.',
          measure:'Sends, clicks, direct bookings, room nights and attributable revenue.',
          recheck,
          trigger:'If pickup stays below '+pace.toFixed(pace<1?2:1)+' room nights/day, move to '+names.capture+'.'
        },
        capture:{
          doNow:'Check rate, availability and direct path for the exact dates, then activate direct/search/OTA visibility around that window.',
          measure:'Booking-engine sessions, conversion, pickup, ADR and direct share.',
          recheck,
          trigger:'If visibility is healthy but pickup remains weak, move to '+names.create_demand+'.'
        },
        create_demand:{
          doNow:'Build one concrete reason to travel on these dates: one segment, one stay proposition and one partner or experience.',
          measure:'Offer views, partner reach, enquiries, bookings and recovered room nights.',
          recheck,
          trigger:'If reach appears but bookings do not, tighten the proposition and add '+names.capture+'.'
        }
      };
      return plans[primary];
    };

    const render = payload => {
      const {c,nights,gap,pace,revenue,scores,ranked,signal,urgency,start,end}=payload;
      root.querySelector('[data-period]').textContent=start+' → '+end;
      root.querySelector('[data-urgency]').textContent=urgencyNames[urgency];
      root.querySelector('[data-gap]').textContent=gap;
      root.querySelector('[data-nights]').textContent=nights;
      root.querySelector('[data-pace]').textContent=pace.toFixed(pace<1?2:1);
      root.querySelector('[data-revenue]').textContent=c.adr>0?new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:'EUR',maximumFractionDigits:0}).format(revenue):'—';
      root.querySelector('[data-diagnosis]').textContent=signalNames[signal];
      root.querySelector('[data-description]').textContent=desc[signal];
      Object.entries(scores).forEach(([k,v])=>{const row=root.querySelector('[data-row="'+k+'"]');row.querySelector('[data-score]').textContent=v;row.querySelector('.lsg-ie__bar i').style.width=v+'%'});
      root.querySelector('[data-sequence]').innerHTML=ranked.map((k,i)=>(i?'<i>→</i>':'')+'<b>'+names[k]+'</b>').join('');
      const plan=actionPlan(ranked[0],signal,urgency,c,pace);
      root.querySelector('[data-do-now]').textContent=plan.doNow;
      root.querySelector('[data-measure]').textContent=plan.measure;
      root.querySelector('[data-recheck]').textContent=plan.recheck;
      root.querySelector('[data-trigger]').textContent=plan.trigger;
    };

    const scan = async () => {
      idle.hidden=true;results.hidden=true;scanner.hidden=false;run.disabled=true;
      const stages=[[15,1,'GAP'],[36,2,'SIGNAL'],[58,3,'PLAYBOOK'],[78,4,'SEQUENCE'],[94,5,'ACTION'],[100,5,'COMPLETE']];
      for(const [p,step,title] of stages){
        root.querySelector('[data-scan-percent]').textContent=String(p).padStart(2,'0')+'%';
        root.querySelector('[data-scan-progress]').style.width=p+'%';
        root.querySelector('[data-scan-title]').textContent=title;
        root.querySelectorAll('[data-step]').forEach(el=>el.classList.toggle('is-active',Number(el.dataset.step)<=step));
        await sleep(p===100?260:310);
      }
      scanner.hidden=true;results.hidden=false;run.disabled=false;
      if(window.innerWidth<1021)results.scrollIntoView({behavior:'smooth',block:'start'});
    };

    form.addEventListener('submit', async e => {
      e.preventDefault();error.hidden=true;
      if(!form.reportValidity())return;
      const d=new FormData(form),start=String(d.get('start')),end=String(d.get('end'));
      const startDate=new Date(start+'T00:00:00'),endDate=new Date(end+'T00:00:00');
      const nights=Math.round((endDate-startDate)/86400000);
      if(!Number.isFinite(nights)||nights<=0){error.textContent='Check-out must be after check-in.';error.hidden=false;return}
      const now=new Date();now.setHours(0,0,0,0);const dta=Math.max(0,Math.ceil((startDate-now)/86400000));
      const c={rooms:+d.get('rooms'),occ:+d.get('occupancy')/100,target:(+d.get('target')||70)/100,adr:+d.get('adr')||0,crm:+d.get('crmSize')||0,direct:(+d.get('direct')||30)/100,demand:String(d.get('marketDemand')||'medium'),booking:d.get('bookingReady')!=='no',segment:d.get('segmentKnown')==='yes',partners:d.get('partners')==='yes',dta};
      const inventory=c.rooms*nights,gap=Math.max(0,Math.ceil(inventory*c.target-inventory*c.occ-1e-9)),pace=gap/Math.max(1,dta),revenue=gap*c.adr;
      const scores=score(c),ranked=Object.entries(scores).sort((a,b)=>b[1]-a[1]).map(([k])=>k),signal=diagnosis(c,gap);
      const urgency=dta<=7?'critical':dta<=14?'high':dta<=30?'medium':'normal';
      render({c,nights,gap,pace,revenue,scores,ranked,signal,urgency,start,end});
      await scan();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lsg-premium-footer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('.lsg-footer-disclosure').forEach(details => {
    if (details.dataset.ready) return;
    details.dataset.ready = 'true';
    const summary = details.querySelector('summary');
    const mobile = window.matchMedia('(max-width:600px)');
    const sync = () => { details.open = !mobile.matches; summary.tabIndex = mobile.matches ? 0 : -1; };
    summary.addEventListener('click', event => { if (!mobile.matches) event.preventDefault(); });
    mobile.addEventListener('change', sync);
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
